(function () {
  const INJECTED_CARD_ID = "fp-collection-inline-media-injected";
  const TWO_COLUMN_BREAKPOINT = 990;
  const THREE_COLUMN_BREAKPOINT = 1300;
  const PAIR_RESULT_COUNT = 2;
  const TRIO_RESULT_COUNT = 3;
  let lastInsertIndex = null;

  function getInsertIndex(cardSize, itemCount) {
    const width = window.innerWidth;

    if (itemCount === PAIR_RESULT_COUNT) {
      return itemCount;
    }
    if (itemCount === TRIO_RESULT_COUNT && cardSize === "single" && width >= TWO_COLUMN_BREAKPOINT) {
      return itemCount;
    }

    if (width < TWO_COLUMN_BREAKPOINT) {
      // 2 column grid
      return cardSize === "double" ? 2 : 3;
    } else if (width < THREE_COLUMN_BREAKPOINT) {
      // 3 column grid
      return cardSize === "double" ? 4 : 5;
    } else {
      // 4 column grid
      return cardSize === "double" ? 6 : 7;
    }
  }

  function injectCard() {
    const source = document.getElementById("fp-collection-inline-media-source");
    if (!source) return;

    const hitsList = document.querySelector("ol.ais-Hits-list");
    if (!hitsList) return;

    const cardSize = source.getAttribute("data-card-size") || "double";

    // Remove previously injected card
    const existing = document.getElementById(INJECTED_CARD_ID);
    if (existing) {
      existing.remove();
    }

    const productItems = hitsList.querySelectorAll(":scope > li.ais-Hits-item");
    const insertIndex = getInsertIndex(cardSize, productItems.length);

    lastInsertIndex = insertIndex;

    // Clone the hidden content into a new list item
    const li = document.createElement("li");
    li.id = INJECTED_CARD_ID;
    li.className = "ais-Hits-item fp-collection-inline-media-item fp-collection-inline-media-item--" + cardSize;

    const content = source.firstElementChild;
    if (!content) return;

    li.appendChild(content.cloneNode(true));

    if (productItems[insertIndex]) {
      hitsList.insertBefore(li, productItems[insertIndex]);
    } else {
      hitsList.appendChild(li);
    }

    // Bind video controls
    var playPauseBtn = li.querySelector(".fp-video-controls__play-pause");
    var muteBtn = li.querySelector(".fp-video-controls__mute");
    var video = li.querySelector("video");
    var poster = li.querySelector(".fp-collection-inline-media__video-poster");
    var iframe = li.querySelector(".fp-collection-inline-media__iframe");

    var playIcon =
      '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-play" fill="none" viewBox="0 0 10 14"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.48177 0.814643C0.81532 0.448245 0 0.930414 0 1.69094V12.2081C0 12.991 0.858787 13.4702 1.52503 13.0592L10.5398 7.49813C11.1918 7.09588 11.1679 6.13985 10.4965 5.77075L1.48177 0.814643Z" fill="currentColor"/></svg>';
    var pauseIcon =
      '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-pause" fill="none" viewBox="0 0 10 14"><rect width="3" height="14" fill="currentColor"/><rect x="7" width="3" height="14" fill="currentColor"/></svg>';
    var volumeOffIcon =
      '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-volume-off" fill="none" viewBox="0 0 24 24"><path d="M11 5L6 9H2v6h4l5 4V5z" fill="currentColor"/><line x1="23" y1="9" x2="17" y2="15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="17" y1="9" x2="23" y2="15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
    var volumeOnIcon =
      '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-volume-on" fill="none" viewBox="0 0 24 24"><path d="M11 5L6 9H2v6h4l5 4V5z" fill="currentColor"/><path d="M15.54 8.46a5 5 0 010 7.07" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M19.07 4.93a10 10 0 010 14.14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

    if (video && playPauseBtn) {
      var isAutoplay = video.autoplay;

      // Mute logic: no mute button = always muted; mute button + autoplay = start muted; mute button + no autoplay = unmuted
      if (!muteBtn) {
        video.muted = true;
      } else if (!isAutoplay) {
        video.muted = false;
      }

      function updatePlayPause() {
        if (video.paused) {
          playPauseBtn.innerHTML = playIcon;
          playPauseBtn.setAttribute("aria-label", "Play video");
        } else {
          playPauseBtn.innerHTML = pauseIcon;
          playPauseBtn.setAttribute("aria-label", "Pause video");
        }
      }

      function updateMute() {
        if (!muteBtn) return;
        if (video.muted) {
          muteBtn.innerHTML = volumeOffIcon;
          muteBtn.setAttribute("aria-label", "Unmute video");
        } else {
          muteBtn.innerHTML = volumeOnIcon;
          muteBtn.setAttribute("aria-label", "Mute video");
        }
      }

      playPauseBtn.addEventListener("click", function (e) {
        e.stopPropagation();
        if (video.paused) {
          video.play();
          // Unmute on play for non-autoplay videos with mute button
          if (muteBtn && !isAutoplay) {
            video.muted = false;
            updateMute();
          }
        } else {
          video.pause();
        }
      });

      if (muteBtn) {
        muteBtn.addEventListener("click", function (e) {
          e.stopPropagation();
          video.muted = !video.muted;
          updateMute();
        });
      }

      video.addEventListener("click", function () {
        if (video.paused) {
          video.play();
          if (muteBtn && !isAutoplay) {
            video.muted = false;
            updateMute();
          }
        } else {
          video.pause();
        }
      });

      video.addEventListener("play", function () {
        updatePlayPause();
        if (poster) poster.classList.add("is-hidden");
      });
      video.addEventListener("pause", updatePlayPause);
      if (muteBtn) video.addEventListener("volumechange", updateMute);

      // Update mute icon to reflect initial state
      updateMute();
    }
  }

  document.addEventListener("algolia.instantSearch.onRender", injectCard);

  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      const source = document.getElementById("fp-collection-inline-media-source");
      if (!source) return;

      const cardSize = source.getAttribute("data-card-size") || "double";
      const hitsList = document.querySelector("ol.ais-Hits-list");
      const itemCount = hitsList
        ? hitsList.querySelectorAll(":scope > li.ais-Hits-item:not(#" + INJECTED_CARD_ID + ")").length
        : 0;
      const newIndex = getInsertIndex(cardSize, itemCount);

      if (newIndex !== lastInsertIndex) {
        injectCard();
      }
    }, 150);
  });
})();
